import { supabase } from './supabaseClient.js';

export const QN_CORE_URL = process.env.REACT_APP_QN_CORE_URL || 'https://qn-core-production.up.railway.app';

// POST autenticado con el access token de Supabase. Devuelve { ok, status, data }.
export async function qnCorePost(path, body) {
    try {
        const { data: sessionData } = await supabase.auth.getSession();
        const token = sessionData?.session?.access_token;
        const res = await fetch(`${QN_CORE_URL}${path}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(body),
        });
        let data = null;
        try { data = await res.json(); } catch { data = null; }
        return { ok: res.ok, status: res.status, data };
    } catch (e) {
        return { ok: false, status: 0, data: { error: 'No pudimos comunicarnos con QuantumNodo. Probá de nuevo.' } };
    }
}
